import {Button, makeStyles } from "@material-ui/core";
import React from "react";
import {useTranslation} from "react-i18next";
import {RefreshCcw as RefreshIcon} from "react-feather";

const useStyles = makeStyles((theme) => ({
	root: {},
	action: {
		marginBottom: theme.spacing(1),
		marginRight: theme.spacing(1)
	}
}));

export const RefreshButton = ({onClick}) => {

	const { t } = useTranslation();
	const classes = useStyles();
    return (
			<Button
					color="primary"
					variant="outlined"
                    onClick={onClick}
					className={classes.action}
					startIcon={
					    <RefreshIcon fontSize="small" />
					}
				>
                    {t('Refresh')}
				</Button>);
}